export default class User
{
    static getUser ()
    {
        let accounts = JSON.parse(localStorage.getItem("accounts", "[]"));
        let currentIndex = localStorage.getItem("currentUserIndex", 0);

        let user = accounts[currentIndex];

        return user;
    }

    static getDecorAndCharacter ()
    {
        let user = User.getUser();
        let decor = user?.decor ?? user?.scene ?? "foret";
        let character = user?.character ?? "octave";

        return {decor, character}
    }

    static setDecor (decor)
    {
        let accounts = JSON.parse(localStorage.getItem("accounts", []));
        let currentIndex = localStorage.getItem("currentUserIndex", 0);

        if (currentIndex == null || currentIndex == undefined)
        {
            currentIndex = 0;
        }

        if (!accounts[currentIndex])
        {
            accounts[currentIndex] = {};
        }

        if (["montagne", "foret", "jungle", "desert"].includes(decor))
        {
            accounts[currentIndex].decor = decor;
        }
        else
        {
            let a = "what";
        }

        document.dispatchEvent(new CustomEvent("save-accounts", {detail: accounts}));
    }

    static setCharacter (character)
    {
        let accounts = JSON.parse(localStorage.getItem("accounts", []));
        let currentIndex = localStorage.getItem("currentUserIndex", 0);

        if (currentIndex == null || currentIndex == undefined)
        {
            currentIndex = 0;
        }

        if (!accounts[currentIndex])
        {
            accounts[currentIndex] = {};
        }

        if (["octave", "coda", "melodie", "alto"].includes(character))
        {
            accounts[currentIndex].character = character;
        }
        else
        {
            let a = "what";
        }

        document.dispatchEvent(new CustomEvent("save-accounts", {detail: accounts}));
    }

    static setPack (pack)
    {
        let accounts = JSON.parse(localStorage.getItem("accounts", []));
        let currentIndex = localStorage.getItem("currentUserIndex", 0);

        if (currentIndex == null || currentIndex == undefined)
        {
            currentIndex = 0;
        }

        if (!accounts[currentIndex])
        {
            accounts[currentIndex] = {};
        }

        if (["pack1", "pack2", "pack3", "pack4"].includes(pack))
        {
            accounts[currentIndex].pack = pack;
        }


        document.dispatchEvent(new CustomEvent("save-accounts", {detail: accounts}));
    }
}
